import { useCallback, useState } from 'react';
import { PaginatedData } from 'models/PaginatedData';
import { EMPTY_ARRAY } from 'data/global';

export default function useTableFetchState<T>(initialData: T[] = EMPTY_ARRAY) {
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  const [data, setData] = useState<T[]>(initialData);

  const setPaginatedData = useCallback((response: PaginatedData<T>) => {
    const { items, totalItems, totalPages } = response || {};

    setData(items);
    setTotalPages(totalPages);
    setTotalItems(totalItems);
  }, []);

  const reset = useCallback(() => {
    setData(initialData);
    setTotalPages(0);
    setTotalItems(0);
  }, [initialData]);

  return {
    isLoading,
    totalPages,
    totalItems,
    data,
    setIsLoading,
    setData,
    setPaginatedData,
    reset,
  };
}
